/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dispatch_Fleet_Specific_HintInputs */

const en_dispatch_fleet_specific_hint = /** @type {(inputs: Dispatch_Fleet_Specific_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forced: if every robot of this fleet is busy, the task fails instead of being reassigned to another fleet.`)
};

const fr_dispatch_fleet_specific_hint = /** @type {(inputs: Dispatch_Fleet_Specific_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forçage : si tous les robots de cette flotte sont occupés, la tâche échouera au lieu de tomber sur une autre flotte.`)
};

const ms_sg2_dispatch_fleet_specific_hint = /** @type {(inputs: Dispatch_Fleet_Specific_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paksa: jika semua robot armada ini sibuk, tugasan akan gagal dan bukan diberikan kepada armada lain.`)
};

/**
* | output |
* | --- |
* | "Forced: if every robot of this fleet is busy, the task fails instead of being reassigned to another fleet." |
*
* @param {Dispatch_Fleet_Specific_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const dispatch_fleet_specific_hint = /** @type {((inputs?: Dispatch_Fleet_Specific_HintInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dispatch_Fleet_Specific_HintInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dispatch_fleet_specific_hint(inputs)
	if (locale === "fr") return fr_dispatch_fleet_specific_hint(inputs)
	return ms_sg2_dispatch_fleet_specific_hint(inputs)
});